export default {
    baseApi: process.env.VUE_APP_BASE_API,
    imAPI: process.env.VUE_APP_IM_API,
    yhzxApi: process.env.VUE_APP_YHZX_API,
    zpApi: process.env.VUE_APP_ZP_API,
    h5HOST: process.env.VUE_APP_H5_HOST,
    mgHost: process.env.VUE_APP_MINGE_HOST, 
    mgApi: process.env.VUE_APP_MINGE_API,
    mgUid: process.env.VUE_APP_MINGE_UID,
    clientKey: process.env.VUE_APP_CLIENT_KEY,
    clientFlag: process.env.VUE_APP_CLIENT_FLAG
}